// Auto-generated from continuous.json - patterns as RLE
const patterns = {
  'default': {
    'Gradient Bloom': {
      rle: 'x = 5, y = 4\n2bo$b3o$5o$2bo!',
      description: 'A compact seed that quickly expands into a smooth, pulsing blob under the continuous rules.',
    },
    'Ripple Band': {
      rle: 'x = 5, y = 5\n2bo$b3o$2ob2o$b3o$2bo!',
      description: 'A thin ridge that sheds concentric waves of energy when evolved with the continuous mode.',
    },
    'Ripple Cross': {
      rle: 'x = 5, y = 5\n2bo$b2o$5o$2b2o$2bo!',
      description: 'Orthogonal arms that throw out concentric ripples as intensities smear.',
    },
    'Soft Glider': {
      rle: 'x = 3, y = 3\nbo$b2o$3o!',
      description: 'A glider-like seed that drifts with smoother gradients under continuous rules.',
    },
    'Spiral Core': {
      rle: 'x = 4, y = 4\n2o$obo$b3o$obo!',
      description: 'Offset cluster that tends to wind into a rotating swirl with soft edges.',
    },
  },
};
export default patterns;
